import { Stack } from '@mui/material';
import AuditContainerComponent from '@screens/admin/audits/components/container/AuditContainer.component';
import PrecoContainerComponent from '@screens/admin/audits/components/container/PrecoContainer.component';
import {
    AiScheduleObj,
    AuditOperation,
    AuditOperationScheduleDto, CreateAuditOperation
} from '@store/audits/audits-operation/audits-operation.model';
import {
    NumeralDayOfMonth,
    WeekDay,
    getNumeralDayOfMonthTranslation, getWeekDayListFromString,
    getWeekDayTranslation
} from '@store/common/schedule.model';
import { getTypeOf } from '@utils/getTypeOf';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ContainerComponentProps {
    isExpended?: boolean;
    auditOperation?: CreateAuditOperation;
    oldValue?: AuditOperation;
    isAudit?: boolean;
}

const ContainerComponent = (props: ContainerComponentProps) => {
    const { isExpended, auditOperation, oldValue, isAudit } = props;
    const [frequency, setFrequency] = useState<AiScheduleObj>();
    const { t } = useTranslation();

    useEffect(() => {
        const handleDisplayFrequency = (value: Partial<AuditOperationScheduleDto>) => {
            const frequency: AiScheduleObj = {
                frequencyType: value.frequency as string,
                frequencyItem: [{
                    title: 'fréquence',
                },
                {
                    title: 'jours',
                }]
            };

            const oldValueItem: AuditOperationScheduleDto | string = oldValue?.schedule ? getTypeOf<AuditOperationScheduleDto>(oldValue.schedule) : '-';

            if (value) {
                switch (value.frequency) {
                    case 'DAILY':
                        frequency.frequencyItem[0].value = value.dailyEveryWeekDay ? t('audits.preco.period-daily') : t('audits.preco.period-every-x-day', { value: value.dailyFrequencyNumber?.toString() });
                        frequency.frequencyItem[0].oldValue = _.isObject(oldValueItem) ? (oldValueItem.dailyEveryWeekDay ? t('audits.preco.period-daily') : t('audits.preco.period-every-x-day', { value: oldValueItem?.dailyFrequencyNumber?.toString() })) : oldValueItem;
                        frequency.frequencyItem[1].value = '-';
                        frequency.frequencyItem[1].oldValue = _.isObject(oldValueItem) ? '-' : oldValueItem;
                        break;
                    case 'WEEKLY':
                        frequency.frequencyItem[0].value = t('audits.preco.period-hebdo', { value: value.weeklyFrequencyNumber });
                        frequency.frequencyItem[0].oldValue = _.isObject(oldValueItem) ? t('audits.preco.period-hebdo', { value: oldValueItem.weeklyFrequencyNumber }) : oldValueItem;
                        frequency.frequencyItem[1].value = getWeekDayListFromString(value.daysOfWeek ?? '');
                        frequency.frequencyItem[1].oldValue = _.isObject(oldValueItem) ? getWeekDayListFromString(oldValueItem.daysOfWeek ?? '') : oldValueItem;
                        break;
                    case 'MONTHLY':
                        frequency.frequencyItem[0].value = t('audits.preco.period-monthly-month', { value: value.monthlyFrequencyNumber });
                        frequency.frequencyItem[0].oldValue = _.isObject(oldValueItem) ? t('audits.preco.period-monthly-month', { value: oldValueItem.monthlyFrequencyNumber }) : oldValueItem;
                        frequency.frequencyItem[1].value = value.dayOfMonth ? t('audits.preco.period-monthly-day', { value: value.dayOfMonth }) : `${getNumeralDayOfMonthTranslation(value.numeralDayOfMonth ?? NumeralDayOfMonth.FIRST)} ${getWeekDayTranslation(value.weekDayForMonth ?? WeekDay.MONDAY)}`;
                        frequency.frequencyItem[1].oldValue = _.isObject(oldValueItem) ? (oldValueItem.dayOfMonth ? t('audits.preco.period-monthly-day', { value: oldValueItem.dayOfMonth }) : `${getNumeralDayOfMonthTranslation(oldValueItem.numeralDayOfMonth ?? NumeralDayOfMonth.FIRST)} ${getWeekDayTranslation(oldValueItem.weekDayForMonth ?? WeekDay.MONDAY)}`) : '-';
                        break;
                }
            }

            setFrequency(frequency);
        };

        if (auditOperation?.schedule)
            handleDisplayFrequency(getTypeOf<AuditOperationScheduleDto>(auditOperation.schedule));
    }, [auditOperation?.schedule, oldValue?.schedule, t]);


    return (
        <Stack justifyContent="center" alignItems="start" height="100%">
            {isAudit ? <AuditContainerComponent oldValue={oldValue} auditOperation={auditOperation} frequency={frequency} /> : <PrecoContainerComponent isExpended={isExpended} oldValue={oldValue} auditOperation={auditOperation} frequency={frequency}/>}
        </Stack>
    );
};

export default ContainerComponent;
